import { useState, useEffect, useRef } from "react";
import { getExpenseApi } from "../../Api/Expense";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa";
import { fetchDonationTypeApi } from "../../Api/DonationTypes";
import { fetchPurposeApi } from "../../Api/PurposeType";
import { VscFilter } from "react-icons/vsc";
import { TbFilterX } from "react-icons/tb";
import { fetchUserByIdApi } from "../../Api/Box";
import { getAllBankApi } from "../../Api/Bank";
import { DonationAnalytics } from "./donationdetails/DonationAnalytics";
import { ExpenseForm } from "./ExpenseForm";
import SideModal from "../general/Sidemodal";
import Filtermodal from "../general/Filtermodal";
import { getTypeApi } from "../../Api/taxonomy";
import { ExpenseCategoryTree } from "./ExpenseCategoryTree";

interface ExpenseInterface {
  typeId: number;
  Id: string;
  type: string;
  SubType: string;
  purpose: string;
  amount: number;
  desc: string;
  from: string;
}

interface ExpenseProps {
  url: string;
  readyear: string;
  isDarkMode: boolean;
}

interface Options {
  value: any;
  type: string;
  parentId: null;
  id: string;
  name: string;
}

export const Expense = ({ url, readyear, isDarkMode }: ExpenseProps) => {
  const [search, setSearch] = useState("");
  const [expenseActiveTab, setExpenseActiveTab] = useState("segment-1");
  const [expenses, setExpenses] = useState<ExpenseInterface[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [filterModal, setfilterModal] = useState(false);
  const [donationtypes, setdonationtypes] = useState<Options[]>([]);
  const [donationpurposes, setdonationpurposes] = useState<Options[]>([]);
  const [expensedata, setexpensedata] = useState<Options[]>([]);
  const [selectedExpenseCategories, setSelectedExpenseCategories] = useState<string[]>([]);
  const [years, setyears] = useState<string[]>([]);
  const [months, setmonths] = useState<string[]>([]);
  const [userNames, setUserNames] = useState<{ [key: string]: string }>({});
  const [bankDetails, setBankDetails] = useState<{
    [key: string]: { name: string; accountNumber: string };
  }>({});
  const [Expenseformmodal, setExpenseformmodal] = useState(false);
  const [updateId, setupdateId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Local filter states
  const [passyear, setpassyear] = useState<string>("");
  const [passmonth, setpassmonth] = useState<string>("");
  const [DonationType, setDonationType] = useState<string>("");
  const [DonationPurpose, setDonationPurpose] = useState<string>("");
  const [mode, setMode] = useState<string>("");

  const ITEMS_PER_PAGE = 10;

  const fetchExpenses = async () => {
    try {
      setIsLoading(true);
      const expenseData = await getExpenseApi(url, {
        year: passyear || '',
        month: passmonth || '',
        searchTerm: search,
        pageNumber: currentPage,
        pageSize: ITEMS_PER_PAGE,
        donationTypeId: DonationType || "",
        donationPurposeId: DonationPurpose || "",
        mode: mode || "",
        expenseCategoryIds: selectedExpenseCategories.length > 0 ? selectedExpenseCategories : undefined,
      });

      const expenses = expenseData.expenses || expenseData || [];
      const totalCount = expenseData.totalCount || expenseData.length || 0;

      setExpenses(expenses);
      setTotalPages(Math.ceil(totalCount / ITEMS_PER_PAGE));
    } catch (error) {
      toast.error("Failed to fetch expense data.");
      setExpenses([]);
      setTotalPages(1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchExpenses();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [search, currentPage]);


  useEffect(() => {
    if (!passyear) {
      setpassmonth('');
    }
  }, [passyear]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchDonationTypeApi(url);
        const filteredDonationTypes = response.filter(
          (item: any) => item.parentId !== null
        );
        setdonationtypes(filteredDonationTypes);
        const res = await fetchPurposeApi(url);
        setdonationpurposes(res as Options[]);
        const expenseresponse = await getTypeApi("Expense Category", url);
        setexpensedata(expenseresponse);        
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchData();
  }, [url]);
  

  useEffect(() => {
    const startYear = parseInt(readyear);
    const currentYear = new Date().getFullYear();
    const generatedYears = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => (startYear + i).toString()
    );
    const generatedMonths = Array.from({ length: 12 }, (_, i) =>
      (i + 1).toString()
    );
    setyears(generatedYears);
    setmonths(generatedMonths);
  }, [readyear]);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const bankData = await getAllBankApi(url);
        const bankMap: {
          [key: string]: { name: string; accountNumber: string };
        } = {};

        bankData.forEach((bank: any) => {
          bankMap[bank.id] = {
            name: bank.name,
            accountNumber: bank.accountNumber,
          };
        });

        setBankDetails(bankMap);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, [url]);

  useEffect(() => {
    const fetchUserNames = async () => {
      const namesMap: { [key: string]: string } = {};

      for (const expense of expenses) {
        if (
          expense.from &&
          !userNames[expense.from] &&
          !bankDetails[expense.from]
        ) {
          try {
            const userData = await fetchUserByIdApi(expense.from, url);
            if (userData?.name) {
              namesMap[expense.from] = userData.name;
            }
          } catch (error) {
            console.error(
              `Error fetching user name for ID ${expense.from}:`,
              error
            );
          }
        }
      }
      setUserNames((prev) => ({ ...prev, ...namesMap }));
    };

    if (expenses.length > 0) {
      fetchUserNames();
    }
  }, [expenses, bankDetails, url]);

  const handleApply = () => {
    setCurrentPage(1);
    fetchExpenses();
    setfilterModal(false);
  };

  const handleClear = async () => {
    setDonationType("");
    setDonationPurpose("");
    setpassyear('');
    setpassmonth('');
    setMode("");
    setSearch("");
    setSelectedExpenseCategories([]);
    setCurrentPage(1);
  };

  return (
    <div className=" h-full px-2 md:px-4 bg-[#ffff]">
      <div className='flex flex-row items-center '>
        <h2 className="text-3xl font-bold text-blue-600 mb-5 mt-5">
          {expenseActiveTab === "segment-1"
            ? "Expense Details"
            : " Expense Analytics"}
        </h2>
        {expenseActiveTab === "segment-1" &&
          <button
            type="button"
            className=" w-fit px-3 py-2 mx-3  tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            onClick={() => {
              setupdateId(null);
              setExpenseformmodal(true);
            }}
          >
            <FaPlus className="w-3 h-3" />
          </button>
        }
      </div>

      <div>
        <div className="flex overflow-x-auto whitespace-nowrap border-b border-gray-300 dark:border-gray-500">
          <button
            className={`inline-flex items-center h-12 px-4 py-2 text-center text-gray-700 border border-b-0 border-gray-300 dark:border-gray-500 rounded-t-md focus:outline-none whitespace-nowrap transition-all 
         ${expenseActiveTab === "segment-1"
                ? "bg-blue-500 dark:bg-blue-700 text-white border-gray-400 dark:border-gray-300"
                : "bg-transparent text-gray-500 hover:border-gray-400 dark:hover:border-gray-300"
              }`}
            onClick={() => setExpenseActiveTab("segment-1")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-database-dollar"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" />
              <path d="M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035" />
              <path d="M20 10v-4" />
              <path d="M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025" />
              <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
              <path d="M19 21v1m0 -8v1" />
            </svg>
            <span className="mx-1 text-sm sm:text-base">Details</span>
          </button>

          <button
            className={`inline-flex items-center h-12 px-4 py-2 text-center text-gray-700 border border-b-0 border-gray-300 dark:border-gray-500 rounded-t-md  focus:outline-none whitespace-nowrap transition-all 
        ${expenseActiveTab === "segment-2"
                ? "bg-blue-500 dark:bg-blue-700 text-white border-gray-400 dark:border-gray-300"
                : "bg-transparent text-gray-500 hover:border-gray-400 dark:hover:border-gray-300"
              }`}
            onClick={() => setExpenseActiveTab("segment-2")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-report-analytics"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
              <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
              <path d="M9 17v-5" />
              <path d="M12 17v-1" />
              <path d="M15 17v-3" />
            </svg>
            <span className="mx-1 text-sm sm:text-base">Analytics</span>
          </button>
        </div>

        <div className="mt-3">
          {expenseActiveTab === "segment-1" && (
            <div role="tabpanel">
              <div className=" flex flex-row gap-2 w-full mt-10   ">
                <div className="mb-4 w-full">
                  <input
                    type="text"
                    placeholder="Search Expenses"
                    className="w-full mb-4 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500 border-gray-300"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </div>
                <div
                  className="flex flex-row gap-1  justify-center px-1 py-2 h-10 w-[90px] hover:bg-gray-100 rounded-md cursor-pointer"
                  onClick={() => setfilterModal(true)}
                >
                  <VscFilter className="text-blue-500 h-7 w-7 " />
                  <span className="text-lg font-normal text-gray-600">
                    Filter
                  </span>
                </div>
              </div>

              <div className="flex-grow ml-0 mt-4 w-full ">
                <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                      <tr>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right  text-gray-500"
                        >
                          Actions
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>Mode</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>From</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>Type</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>SubType</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>Donation Type</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>Donation Purpose</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          <span>Amount</span>
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          Expense On
                        </th>
                        <th
                          scope="col"
                          className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                        >
                          Description
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                      {isLoading ? (
                        <tr>
                          <td colSpan={9} className="px-4 py-4 text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : expenses.length === 0 ? (
                        <tr>
                          <td colSpan={9} className="px-4 py-4 text-center">
                            No expenses found
                          </td>
                        </tr>
                      ) : (
                        expenses
                          .sort(
                            (a: any, b: any) =>
                              new Date(b.expenseOn).getTime() -
                              new Date(a.expenseOn).getTime()
                          )
                          .map((expense: any, index: any) => (

                            <tr className="bg-[#ffff] text-gray-500" key={index}>
                              <td className="px-4 py-4 text-sm whitespace-nowrap">
                                <div className="flex items-center gap-x-6">
                                  <button
                                    onClick={() => {
                                      setupdateId(expense.id);
                                      setExpenseformmodal(true);
                                    }}
                                    className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      className="w-5 h-5"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </td>
                              <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                {expense.mode}
                              </td>
                              <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                {userNames[expense.from] ||
                                  (bankDetails[expense.from]
                                    ? `${bankDetails[expense.from].name} - ${bankDetails[expense.from].accountNumber
                                    }`
                                    : "")}
                              </td>
                              <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                {expense.type}
                              </td>
                              <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                {expense.subType}
                              </td>
                              <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                {expense.donationType}
                              </td>
                              <td className="px-4 py-4 text-sm text-gray-500">
                                {expense.donationPurpose}
                              </td>
                              <td className="px-4 py-4 text-sm text-gray-500">
                                {expense.amount}
                              </td>
                              <td className="px-4 py-4 text-sm text-gray-500">
                                {new Date(expense.expenseOn).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  }
                                )}
                              </td>
                              <td className="px-4 py-4 text-sm  text-gray-500">
                                {expense.desc}
                              </td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="flex items-center justify-between mt-6">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-5 h-5 rtl:-scale-x-100"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                      />
                    </svg>
                    <span>Previous</span>
                  </button>

                  <div className="items-center hidden lg:flex gap-x-3">
                    {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
                      const startPage = Math.max(1, currentPage - 5);
                      const page = startPage + index;

                      if (page > totalPages) return null;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-2 py-1 text-sm ${currentPage === page
                            ? "text-blue-500 bg-blue-100"
                            : "text-gray-500 hover:bg-gray-100"
                            } rounded-md`}
                        >
                          {page}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
                  >
                    <span>Next</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-5 h-5 rtl:-scale-x-100"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </button>
                </div>

                {/* filter modal */}
                <Filtermodal isOpen={filterModal} onClose={() => setfilterModal(false)} >
                  <div className="p-2">
                    <h2 className="text-xl font-semibold text-blue-700 mb-4">Expense Details Filters</h2>
                    <div className="flex items-center gap-4 mb-4">
                      <button
                        onClick={handleClear}
                        className="cursor-pointer flex items-center gap-2 hover:bg-gray-200 px-2 py-1 rounded-md border border-gray-200 shadow-sm"
                      >
                        <TbFilterX className="h-5 w-5" />
                        Clear all
                      </button>
                    </div>
                    <div className="mb-4">
                      <label className="block text-base font-semibold text-gray-900 mb-1">Mode:</label>
                      <select
                        id="mode"
                        value={mode}
                        onChange={(e) => setMode(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                      >
                        <option value="">All</option>
                        <option value="Bank">Bank</option>
                        <option value="Cash">Cash</option>
                      </select>
                    </div><div className="mb-4">
                      <ExpenseCategoryTree
                        categories={expensedata}
                        selectedCategories={selectedExpenseCategories}
                        onSelectionChange={setSelectedExpenseCategories}
                        isDarkMode={isDarkMode}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-base font-semibold text-gray-900 mb-1">Year:</label>
                      <select
                        value={passyear}
                        onChange={(e) => setpassyear(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select Year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-4">
                      <label className="block text-base font-semibold text-gray-900 mb-1">Month:</label>
                      <select
                        value={passmonth}
                        onChange={(e) => setpassmonth(e.target.value)}
                        disabled={!passyear}
                        className={`w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400 ${!passyear ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      >
                        <option value="">Select Month</option>
                        {months.map((month) => (
                          <option key={month} value={month}>{month}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-4">
                      <label className="block text-base font-semibold text-gray-900 mb-1">Donation Type:</label>
                      <select
                        id="donationType"
                        value={DonationType}
                        onChange={(e) => setDonationType(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select Donation Type</option>
                        {donationtypes.map((option) => (
                          <option key={option.id} value={option.id}>{option.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-4">
                      <label className="block text-base font-semibold text-gray-900 mb-1">Donation Purpose:</label>
                      <select
                        id="donationPurpose"
                        value={DonationPurpose}
                        onChange={(e) => setDonationPurpose(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select Donation purpose</option>
                        {donationpurposes.map((option) => (
                          <option key={option.id} value={option.id}>{option.name}</option>
                        ))}
                      </select>
                    </div>                  
                    <div className="flex gap-2 mt-6 justify-start">
                      <button
                        className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                      <button
                        className="px-4 py-2 border border-gray-400 rounded hover:bg-gray-100 transition"
                        onClick={() => setfilterModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </Filtermodal>
              </div>
            </div>
          )}
          {expenseActiveTab === "segment-2" && (
            <div role="tabpanel">
              <DonationAnalytics
                isDarkMode={isDarkMode}
                url={url}
                readyear={readyear}
                donationtypes={donationtypes}
                donationpurposes={donationpurposes}
              />
            </div>
          )}
        </div>
      </div>

      <SideModal isOpen={Expenseformmodal} onClose={() => setExpenseformmodal(false)}>
        <ExpenseForm
          url={url}
          setformmodal={setExpenseformmodal}
          id={updateId}
          onSuccess={() => fetchExpenses()}
          onClose={() => {
            setExpenseformmodal(false);
          }}
        />
      </SideModal>
    </div>
  );
};
